
import React from 'react';
import { Camera, Eye } from 'lucide-react';
import { Project, Photo } from '../types';

interface PhotoGalleryProps {
  project: Project;
  onTakePhoto: () => void;
  onViewPhoto: (photo: Photo) => void;
}

export const PhotoGallery: React.FC<PhotoGalleryProps> = ({ project, onTakePhoto, onViewPhoto }) => {
  return (
    <div className="space-y-6 animate-fadeIn pb-24">
       <div className="flex items-center justify-between">
          <h2 className="text-3xl font-black uppercase tracking-tighter">Galeria</h2>
          <button onClick={onTakePhoto} className="bg-indigo-600 text-white p-3 rounded-xl shadow-lg hover:scale-105 transition-transform"><Camera size={20}/></button>
       </div>
       
       <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
          {project.photos.map(photo => (
             <div key={photo.id} onClick={() => onViewPhoto(photo)} className="aspect-[4/5] rounded-2xl overflow-hidden relative group cursor-pointer border border-slate-200 dark:border-slate-800">
                <img src={photo.url} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" alt="" />
                <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                   <Eye className="text-white" size={24} />
                </div>
                <div className="absolute bottom-2 left-2 right-2">
                   <div className="bg-white/90 dark:bg-black/80 backdrop-blur-sm px-2 py-1 rounded-lg text-[8px] font-black uppercase tracking-widest truncate text-center">
                      {photo.room}
                   </div>
                </div>
             </div>
          ))}
       </div>
    </div>
  );
};
